import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { css } from '@emotion/core';
import { Icon, Tag as DefaulTag } from 'antd';
import styled from '@emotion/styled';
import Input from '../../common/Input';

const tagStyle = css`
  display: block;
  width: 90px;
`;

const TagInput = styled(Input)`
  font-size: ${({ theme }) => theme.fontSize.small};
`;

const Tag = styled(DefaulTag)`
  margin-right: 5px;
  margin-top: 10px;
`;

class Labels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputVisible: false,
      inputValue: '',
    };
    this.textInput = React.createRef();
    this.showInput = this.showInput.bind(this);
    this.closeInput = this.closeInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  showInput() {
    this.setState({ inputVisible: true }, () => this.textInput.current.focus());
  }

  closeInput() {
    const { addLabel } = this.props;
    const { inputValue } = this.state;
    if (inputValue !== '') {
      addLabel(inputValue);
    }
    this.setState({ inputVisible: false, inputValue: '' });
  }

  handleChange(e) {
    this.setState({ inputValue: e.target.value });
  }

  render() {
    const { inputVisible, inputValue } = this.state;
    const { labels, removeLabel } = this.props;
    return (
      <div>
        <FormattedMessage id="common.typeLabel">
          {placeholder => (
            <Fragment>
              {inputVisible ? (
                <TagInput
                  value={inputValue}
                  placeholder={placeholder}
                  ref={this.textInput}
                  onPressEnter={this.closeInput}
                  onBlur={this.closeInput}
                  onChange={this.handleChange}
                  css={tagStyle}
                  width="90px"
                />
              ) : (
                <DefaulTag css={tagStyle} onClick={this.showInput}>
                  <Icon type="plus" /> New Label
                </DefaulTag>
              )}
              {labels.map(({ id, text }) => (
                <Tag key={id} afterClose={() => removeLabel(id)} closable>
                  {text}
                </Tag>
              ))}
            </Fragment>
          )}
        </FormattedMessage>
      </div>
    );
  }
}

Labels.defaultProps = {
  labels: [],
};

Labels.propTypes = {
  addLabel: PropTypes.func.isRequired,
  labels: PropTypes.arrayOf(PropTypes.object),
  removeLabel: PropTypes.func.isRequired,
};

export default Labels;
